import { render, staticRenderFns } from "./AppAlarm.vue?vue&type=template&id=b2e1299a&scoped=true"
import script from "./AppAlarm.vue?vue&type=script&lang=js"
export * from "./AppAlarm.vue?vue&type=script&lang=js"
import style0 from "./AppAlarm.vue?vue&type=style&index=0&id=b2e1299a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e1299a",
  null
  
)

export default component.exports